import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const modelRouter: Array<RouteConfig> = [
  {
    path: "models_list",
    name: "models_list",
    component: () => import("@/views/Models/ModelsList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "models_list/:id",
    name: "modelId",
    component: () => import("@/views/Models/Model.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "models_list/create_model",
    name: "new_model",
    component: () => import("@/views/Models/NewModel.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  }
];

export default modelRouter;
